import api from "../services/api";

export const getActionLogsList = (queryParams = "") => {
    return api.get(`/admin/user/action/logs${queryParams}`);
};